/**
 * Controller: donationsAmountCreateModal
 */
angular.module('acme.view.application.donations.amount.createModal.controllers', [
  'ui.bootstrap',
  'acme.common.service.templates'
])
.controller('DonationsAmountCreateModalController', [ '$scope', '$uibModalInstance', 'TemplatesService', 'inventory', 'currentInventory', 'hasDonation', function ($scope, $uibModalInstance, TemplatesService, inventory, currentInventory, hasDonation) {

  $scope.errors = [];

  $scope.mode = 'create';
  $scope.title = 'Create';
  $scope.showPrice = true;
  $scope.model = {
    name: '',
    description: '',
    quantity: 0,
    sku: '',
    type: 'fixedDonation',
    price: 0,
    printTicket: true,
    salesChannels: TemplatesService.orderSalesChannels(angular.copy(TemplatesService.salesChannels))
  };

  $scope.selected = {
    inventoryType: {}
  };

  $scope.cachedTypes = [];

  $scope.types = [
    {
      name: 'donation',
      label: 'Variable Donation',
      visible: true
    },
    {
      name: 'fixedDonation',
      label: 'Fixed Donation',
      visible: true
    }
  ];

  $scope.init = function() {

    if (currentInventory) {
      $scope.mode = 'edit';
      $scope.title = 'Edit';
      $scope.model = currentInventory;
      if ($scope.model.type === 'doNotTrack') {
        $scope.selected.inventoryType = $scope.types[(($scope.model.printTicket) ? 0 : 1)].name;
      }else{
        $scope.selected.inventoryType = $scope.model.type;
      }
    }else{
      $scope.selected.inventoryType = $scope.model.type;
    }

    $scope.cachedTypes = angular.copy($scope.types);

    if (hasDonation && hasDonation.length && $scope.model.type !== 'donation') {
      $scope.types.splice(0, 1);
    }
  };

  $scope.updateInventoryType = function() {
    if ($scope.selected.inventoryType === 'donation') {
      $scope.showPrice = false;
      $scope.model.price = 0;
    }else{
      $scope.showPrice = true;
    }
  };

  $scope.isMode = function(mode) {
    return ($scope.mode === mode);
  };

  $scope.hasErrors = function() {
    return ($scope.errors.length > 0);
  };

  $scope.trim = function(s) {
    return s.replace(/\s+/g, '').toLowerCase();
  };

  $scope.isUnique = function() {
    var i, ii,
      trimmed,
      trimmedCurrent = $scope.trim($scope.model.name),
      r = true;

    for (i=0,ii=inventory.length;i<ii;i++) {
      trimmed = $scope.trim(inventory[i].name);
      if (trimmedCurrent === trimmed) {
        r = false;
        break;
      }
    }

    return r;

  };

  $scope.isDonationSalesChannel = function(channel) {
    var r = true;
    if (channel === 'manualEntry' || channel === 'kiosk') {
      r = false;
    }
    return r;
  };

  $scope.done = function() {
    if ($scope.isMode('create')) {
      if ($scope.isUnique()) {
        if ($scope.model.name.replace(/\s+/g, '').length > 0) {
          $scope.success();
        } else {
          $scope.errors.push({message: 'Please enter a valid name'});
        }
      } else {
        $scope.errors.push({message: 'An Amount named "' + $scope.model.name + '" already exists'});
      }
    }else if ($scope.isMode('edit')) {
      if ($scope.model.name.replace(/\s+/g, '').length > 0) {
        $scope.success();
      } else {
        $scope.errors.push({message: 'Please enter a valid name'});
      }
    }
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $scope.model.printTicket = false;
    $scope.model.type = $scope.selected.inventoryType;
    $uibModalInstance.close($scope.model);
  };

  $scope.init();


}]);
